import { useEffect } from "react";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import classNames from "classnames";
import "./NotificationModal.scss";

const NotificationModal = ({ isOpen, onClose, message, icon, duration = 3500, type = "success" }) => {

    useEffect(() => {
        if (isOpen && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [isOpen, duration, onClose]);

    if (!isOpen) return null;

    return (
        <div className={classNames("notification-modal", type)}>
            <p>{message}</p>
            <Button variant="notification" onClick={onClose}>
                <Icon svg={icon} />
            </Button>
        </div>
    );
};

export default NotificationModal;